import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useSearchParams,
    useSubmit
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.object_id;
    const searchParams = new URL(request.url).searchParams;
    const children_id = searchParams.get("children_id");
    return (await api.get(`api/rate/child/0/${children_id}/`)).data.form;
}

export async function action({request, params}) {
    const formData = await request.formData();
    const obj_id = params.object_id;
    const children_id = formData.get("children_id");
    try {
        const response = await api.post(`api/rate/child/0/${children_id}/`, formData);

        if (response.status === 201) {
            showSnackbar("Тариф успішно додан!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/tariffs`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при додаванні тарифу', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при додаванні тарифу ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
    return null;
}

export default function ObjectTariffsAdd() {
    const {object_id} = useParams();
    const [searchParams] = useSearchParams();
    const childrenId = searchParams.get("children_id");
    const submit = useSubmit();
    const formHook = useForm();
    const revalidator = useRevalidator();
    const loaderData = useLoaderData();
    const actionData = useActionData();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, children_id: childrenId});
        submit(formData, {
            method: 'post'
        })
    }

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/tariffs`}
            title={{text: 'Додати новий тариф'}}
        >
            <PageTitle title={`Новий тариф: ${childrenId || object_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={loaderData}
                formName='HotelRates'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
